/* global Android  */

export function callNativeApp(to, targetTab) {
    if (targetTab) {
        try {
            if (Android) {
                Android.callNativeApp(window.location.origin + to, targetTab);
            }
        } catch (err) {
            const target = {
                url: window.location.origin + to,
                tab: targetTab,
            };

            if (window.webkit) {
                window.webkit.messageHandlers.buttonClicked.postMessage(target);
            }
        }
    }
}
